<template>
  <div>
    {{pageValue}}
    <div @click="setIconStatus" style="display: inline-block;" v-if="encryptValue">
      <icon-svg :name="iconName" />
    </div>
  </div>
</template>

<script>
import { splitEncrypt } from '@/utils/index';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    encryptValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iconName: 'icon-closed-eye',
      isOpen: false, // 默认关上
    };
  },
  computed: {
    pageValue() {
      if (!this.encryptValue) {
        return '-';
      }
      if (this.value && this.isOpen) {
        return this.value;
      }
      return splitEncrypt(this.encryptValue)[0];
    },
  },
  methods: {
    async setIconStatus() {
      this.isOpen = !this.isOpen;
      this.iconName = this.isOpen ? 'icon-eye-o' : 'icon-closed-eye';
      if (this.encryptValue && !this.value) {
        const data = await this.$store.dispatch('dictionary/getDecryptData', {
          encryptData: splitEncrypt(this.encryptValue)[1],
        });
        this.$emit('update:value', data.decryptData);
      }
      this.$emit('change', this.isOpen);
    },
  },
};
</script>
